// ============================================
// HEROSHHI - FORGOT PASSWORD
// File: src/pages/auth/ForgotPasswordPage.jsx
// Same request as before; the look comes from AuthLayout.jsx.
// ============================================

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';
import AuthLayout, { Field, Notice, SubmitButton } from './AuthLayout';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${config.API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await response.json();
      if (data.success) setSuccess(true);
      else setError(data.message || 'We couldn\'t send the email. Please try again.');
    } catch (err) {
      setError('We couldn\'t reach Heroshhi. Check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <AuthLayout>
        <h1>Check your email</h1>
        <p className="hs-auth-sub">If there's an account for this address, we've sent a link to choose a new password:</p>
        <span className="hs-email-chip">{email}</span>
        <p className="hs-auth-sub">The link works for one hour. Nothing yet? Look in your spam folder, or{' '}
          <button type="button" className="hs-link-btn" onClick={() => setSuccess(false)}>send it again</button>.
        </p>
        <Link to="/login" className="hs-btn quiet" style={{ textDecoration: 'none' }}>Back to sign in</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <Link to="/login" className="hs-back">Back to sign in</Link>
      <h1>Forgot your password?</h1>
      <p className="hs-auth-sub">Type the email you sign in with, and we'll send you a link to choose a new one.</p>
      {error && <Notice>{error}</Notice>}
      <form onSubmit={handleSubmit}>
        <Field id="email" label="Email">
          <input id="email" type="email" value={email} onChange={(e) => { setEmail(e.target.value); setError(''); }}
            className="hs-input" placeholder="you@yourbusiness.com" required autoComplete="email" autoFocus />
        </Field>
        <SubmitButton loading={loading} loadingText="Sending">Send the link</SubmitButton>
      </form>
      <p className="hs-auth-foot">Remembered it? <Link to="/login">Sign in</Link></p>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;